var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 45.5H15.75C12.5011 45.5 9.38526 44.2094 7.08794 41.9121C4.79062 39.6147 3.5 36.4989 3.5 33.25C3.5 30.0011 4.79062 26.8853 7.08794 24.5879C9.38526 22.2906 12.5011 21 15.75 21C16.7749 20.9996 17.796 21.1245 18.7906 21.3719",
    stroke: "#999999",
    strokeWidth: 1.30233,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 28C17.5 25.2271 18.1589 22.4939 19.4225 20.0256C20.6861 17.5573 22.5181 15.4246 24.7676 13.8033C27.0171 12.1819 29.6197 11.1183 32.3609 10.7002C35.102 10.282 37.9034 10.5212 40.534 11.398C43.1646 12.2749 45.5492 13.7644 47.4912 15.7436C49.4333 17.7229 50.8772 20.1353 51.704 22.7821C52.5308 25.4288 52.7168 28.2342 52.2467 30.967C51.7765 33.6997 50.6637 36.2817 49 38.5",
    stroke: "#999999",
    strokeWidth: 1.30233,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8343 35.4156L33.2499 28L40.6655 35.4156",
    stroke: "#999999",
    strokeWidth: 1.30233,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.25 45.5V28",
    stroke: "#999999",
    strokeWidth: 1.30233,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudArrowUp);
export default __webpack_public_path__ + "static/media/CloudArrowUp.e05a3b521fef7236936dfc35e6b6900e.svg";
export { ForwardRef as ReactComponent };